angular.module 'zc.projects'

.service 'theme', ($filter) ->
  system:
    message: """
             #{$translate.instant('projects.controllers.invitationNew.setupStep')}
             #{$translate.instant('projects.controllers.invitationNew.setupInitial')}

             #{$translate.instant('projects.controllers.invitationNew.setupTracking')}
             #{$translate.instant('projects.controllers.invitationNew.setupConversion')}
             #{$translate.instant('projects.controllers.invitationNew.setupPage')}
             #{$translate.instant('projects.controllers.invitationNew.setupDomain')}
             #{$translate.instant('projects.controllers.invitationNew.setupVisit')}
             #{$translate.instant('projects.controllers.invitationNew.setupExcludedIp')}
             """
  default:
    message: ''

.controller 'NewInvitationCtrl', ($scope, $state, $translate, $stateParams, currentUser, Page, Devise, theme) ->

  $scope.projectId = $stateParams.projectId
  $scope.theme = $stateParams.theme
  $scope.full_name = currentUser.full_name
  Page.setBodyClass ''
  $translate('projects.controllers.invitationNew.inviteMembers').then (translation) ->
    Page.setTitle translation

  if theme[$scope.theme]
    $scope.email =
      message: theme[$scope.theme].message
  else
    $scope.email =
      message: theme.default.message

  $scope.send = (email) ->
    Devise.invite email



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/controllers/invitation/new.js.coffee